import { useEffect, useState } from "react";
import { Pin, Calendar } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { Reveal } from "@/components/site/primitives";
import { api } from "@/lib/api";
import { IMAGES } from "@/data/content";
import { useSEO } from "@/hooks/useSite";

export default function Announcements() {
  const [items, setItems] = useState([]);
  useSEO({
    title: "News & Announcements | IAUE School of Basic Studies",
    description: "Latest news, admission announcements and important notices from the School of Basic Studies, IAUE Port Harcourt.",
  });
  useEffect(() => { api.get("/announcements").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  return (
    <>
      <PageHero overline="News & Announcements" title="Announcements"
        subtitle="Stay up to date with admission notices, programme updates and important information." crumb="Announcements" image={IMAGES.campus} />

      <section className="py-16 sm:py-24 bg-white">
        <div className="container-x max-w-4xl">
          {items.length === 0 && <p className="text-center text-slate-500 py-10">No announcements yet.</p>}
          <div className="space-y-6">
            {items.map((a, i) => (
              <Reveal key={a.id} delay={(i % 3) * 0.06}>
                <article className="rounded-sm border border-slate-200 bg-[#F7F5EF] p-7 border-l-4" style={{ borderLeftColor: a.pinned ? "#C0202A" : "#D4AF37" }}>
                  <div className="flex flex-wrap items-center gap-3 text-xs">
                    <span className="rounded-full bg-[#0A1E4E] px-3 py-1 font-semibold uppercase tracking-wide text-[#D4AF37]">{a.category}</span>
                    {a.pinned && <span className="inline-flex items-center gap-1 font-semibold text-[#C0202A]"><Pin size={12} /> Pinned</span>}
                    <span className="inline-flex items-center gap-1 text-slate-500"><Calendar size={13} /> {a.date}</span>
                  </div>
                  <h2 className="mt-3 font-serif text-2xl font-bold text-[#0A1E4E]">{a.title}</h2>
                  <p className="mt-2 text-slate-600 leading-relaxed">{a.body}</p>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
